import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import Modal from "../../../utils/Modal";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextareaAutosize,
  Typography,
  useTheme,
} from "@mui/material";

import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  getAvailableSlot,
  getQueryType,
  requestSlot,
} from "../../../actions/availability";
import { BR_EMAIL } from "../../../utils/constants";
import MeetingScheduler from "./MeetingScheduler";
import { closeScheduleModal } from "../../../actions/scheduleActions";

const ContactBox = ({ fromApplication }) => {
  const dispatch = useDispatch();
  const isScheduleOpen = useSelector((state) => state.schedule.isOpen);
  const [openEmail, setOpenEmail] = useState(false);
  const [openPhone, setOpenPhone] = useState(false);
  const handleClickEmailOpen = () => {
    setOpenEmail(true);
  };

  const handleClickPhoneOpen = () => {
    setOpenPhone(true);
  };

  React.useEffect(() => {
    if (isScheduleOpen) {
      handleClickPhoneOpen();
      dispatch(closeScheduleModal());
    }
  }, [isScheduleOpen, dispatch]);

  const mailDialogTitle = "";

  const [queryCode, setQueryCode] = useState("");
  const { requestTimeSlotLoading } = useSelector((state) => state.availability);

  const contactDialogTitle = "Contact US";
  const authUserData = JSON.parse(sessionStorage.getItem("loggedUserData"));
  const current_user = authUserData?.user_data?.invoffuserid;
  const fullName = `${authUserData?.user_data?.first_name ?? ""} ${
    authUserData?.user_data?.last_name ?? ""
  }`;
  const companyName = `(${authUserData?.user_data?.company?.name})`;
  const user_email = authUserData?.user_data?.username;
  const [userValue, setUserValue] = useState();
  const [description, setDescription] = useState("");
  const [times, setTimes] = useState(null);

  const [openBigModal, setOpenBigModal] = useState();

  const handlePhoneConfirm = () => {
    const code = queryCode;
    const user_id = userValue?.user_id;
    const payload = {
      request_by_id: current_user,
      request_by_email: user_email,
      subject: `${fullName}${companyName}`,
      description: description,
      start_date_time: times?.start_datetime,
      end_date_time: times?.end_datetime,
    };
    dispatch(
      requestSlot({ code, current_user, user_id, payload, setOpenPhone })
    );
  };

  const handleEmailConfirm = () => {
    window.open(`mailto:${BR_EMAIL}`, "_blank");
  };
  useEffect(() => {
    if (!openPhone) {
      setUserValue(null);
    }
  }, [openPhone]);

  return (
    <Paper
      elevation={2}
      sx={{
        position: fromApplication ? "" : "relative",
        zIndex: 50,
        top: fromApplication && 450,
        left: fromApplication && 20,
        textAlign: "center",
        borderRadius: 2,
        width: "fit-content",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Button
          id="contact-us-email"
          variant="outlined"
          onClick={handleClickEmailOpen}
          sx={{
            border: 0,
            p: 0,
            width: "40px",
            height: "40px",
          }}
        >
          <EmailOutlinedIcon />
        </Button>
        <Button
          id="contact-us-phone"
          variant="outlined"
          onClick={handleClickPhoneOpen}
          sx={{
            border: 0,
            p: 0,
            width: "40px",
            height: "40px",
          }}
        >
          <PhoneOutlinedIcon />
        </Button>
        {/* <Button
          variant="outlined"
          sx={{
            border: 0,
            p: 0,
            width: "40px",
            height: "40px",
          }}
        >
          <Chat color="primary" sx={{ margin: "10px auto" }} />
        </Button> */}
      </Box>
      {/* email modal */}
      <Modal
        open={openEmail}
        maxWidth={"610px"}
        setOpen={setOpenEmail}
        handleClickOpen={handleClickEmailOpen}
        modalType="schedule"
        dialogContent={<EmailContent />}
        dialogTitle={mailDialogTitle}
        handleConfirm={handleEmailConfirm}
      />
      {/* phone modal */}
      <Modal
        maxWidth={openBigModal ? "1250px" : "600px"}
        isLoading={requestTimeSlotLoading}
        fromContactBox={true}
        padding="20px"
        times={times}
        open={openPhone}
        setOpen={setOpenPhone}
        handleClickOpen={handleClickPhoneOpen}
        modalType="schedule"
        dialogContent={
          <PhoneContent
            setOpenBigModal={setOpenBigModal}
            userValue={userValue}
            setUserValue={setUserValue}
            times={times}
            setTimes={setTimes}
            setDescription={setDescription}
            description={description}
            queryCode={queryCode}
            setQueryCode={setQueryCode}
          />
        }
        dialogTitle={contactDialogTitle}
        handleConfirm={handlePhoneConfirm}
      />
    </Paper>
  );
};

export const PhoneContent = ({
  setOpenBigModal,
  queryCode,
  times,
  setTimes,
  userValue,
  setUserValue,
  description,
  setDescription,
  setQueryCode,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { queryType } = useSelector((state) => state.availability);

  const [queryValue, setQueryValue] = useState(null);
  const [userList, setuserList] = useState([]);
  const [durationValue, setDurationValue] = useState("");
  const [secondPageStep, setSecondPageStep] = useState(false);

  const durationList = [
    {
      value: "15",
      label: "15 Minutes",
    },
    {
      value: "30",
      label: "30 Minutes",
    },
    {
      value: "60",
      label: "60 Minutes",
    },
  ];

  const handleQuerySelect = (e) => {
    setQueryValue(e.target.value);
    const { code, customer_support } = e.target.value;
    setQueryCode(code);
    setuserList(customer_support);
  };

  const handleUserSelect = (e) => {
    const selectedUser = e.target.value;
    setUserValue(selectedUser);
  };

  const handleDuration = (e) => {
    const value = e.target.value;
    setDurationValue(value);
  };

  useEffect(() => {
    dispatch(getQueryType());
  }, [dispatch]);

  const goBack = () => {
    setQueryValue(null);
    setuserList([]);
    setUserValue(null);
    setTimes(null);
    setDurationValue("");
    setSecondPageStep(false);
    setDescription("");
  };

  useEffect(() => {
    if (queryCode && userValue?.user_id && durationValue) {
      setOpenBigModal(true);
    } else {
      setOpenBigModal(false);
    }
  }, [queryCode, userValue?.user_id, durationValue]);

  return (
    <div>
      {!secondPageStep ? (
        <Box>
          {!(queryValue?.type && userValue?.user_id && durationValue) ? (
            <>
              <Typography variant="body1" sx={{ mb: 5 }}>
                Please Choose Query Type from an available options below
              </Typography>
              <Box>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Query Type
                  </InputLabel>
                  <Select
                    id="query-select"
                    onChange={handleQuerySelect}
                    name="query"
                    value={queryValue}
                    margin="normal"
                    required
                    autoComplete="confirm-password"
                  >
                    {queryType?.data?.map((items) => {
                      return (
                        <MenuItem key={items?.id} value={items}>
                          {items.type}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {userList && userList?.length > 0 && (
                  <>
                    <FormControl sx={{ mt: 3 }} fullWidth>
                      <InputLabel id="select-user">Select User</InputLabel>
                      <Select
                        id="user-select"
                        onChange={handleUserSelect}
                        name="select"
                        value={userValue}
                        margin="normal"
                        required
                      >
                        {userList?.map((items, index) => {
                          return (
                            <MenuItem key={index} value={items}>
                              {items?.user_full_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ mt: 3 }} fullWidth>
                      {/* duration */}
                      <InputLabel id="select-user">Select Duration</InputLabel>
                      <Select
                        id="duration-select"
                        onChange={handleDuration}
                        name="select"
                        value={durationValue}
                        margin="normal"
                        required
                      >
                        {durationList?.map((items, index) => {
                          return (
                            <MenuItem key={index} value={items?.value}>
                              {items?.label}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </>
                )}
              </Box>
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignContent: "start",
                }}
              >
                <Button
                  id="change-details-button"
                  onClick={() => goBack()}
                  variant="text"
                  startIcon={<ChevronLeftIcon />}
                >
                  Change Details
                </Button>
              </Box>
              <MeetingScheduler
                setOpenBigModal={setOpenBigModal}
                queryValue={queryValue}
                userValue={userValue}
                durationValue={durationValue}
                setTimes={setTimes}
                setSecondPageStep={setSecondPageStep}
                setDescription={setDescription}
              />
            </>
          )}
        </Box>
      ) : (
        <>
          <TableContainer
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Table sx={{ width: 250 }} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{ padding: 1, border: 0 }}
                    component="th"
                    scope="row"
                  >
                    <Typography
                      sx={{ fontWeight: "bold", textAlign: "right" }}
                      component="p"
                      variant="body"
                    >
                      {" "}
                      Date:
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ padding: 1, border: 0 }}>
                    {moment(times?.start_datetime).format("DD-MM-YYYY")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ padding: 1, border: 0 }}
                    component="th"
                    scope="row"
                  >
                    <Typography
                      sx={{ fontWeight: "bold", textAlign: "right" }}
                      component="p"
                      variant="body"
                    >
                      {" "}
                      Time:
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ padding: 1, border: 0 }}>
                    {moment(times?.start_datetime).format("HH:mm")} -{" "}
                    {moment(times?.end_datetime).format("HH:mm")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ textAlign: "center" }}>
            <Button
              id="change-date-time-button"
              onClick={() => {
                setDescription("");
                setOpenBigModal(true);
                setSecondPageStep(false);
              }}
              variant="text"
            >
              Change Date & Time
            </Button>
          </Box>
          <Typography component="p" variant="body" gutterBottom>
            To help us be best prepared, please briefly tell us what you’d like
            to discuss:
          </Typography>
          <TextareaAutosize
            id="description-textarea"
            aria-label="minimum height"
            minRows={3}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            placeholder=""
            style={{
              fontFamily: "stolzl",
              width: "100%",
              borderRadius: "20px",
              minHeight: "50px",
              padding: "20px",
              borderColor: theme.palette.primary.main,
            }}
          />
        </>
      )}
    </div>
  );
};

export const EmailContent = () => {
  return (
    <Typography component="p" variant="body" sx={{ textAlign: "center" }}>
      {/* If you would like to email, please contact your dedicated expert James at{" "} */}
      Please use this link to email the BareRock team at
      <a
        style={{ marginLeft: "4px" }}
        target="_blank"
        href={`mailto:${BR_EMAIL}`}
        rel="noreferrer"
      >
        {BR_EMAIL}
      </a>
    </Typography>
  );
};

export default ContactBox;
